import DeleteAction from '../DeleteAction';
import PartNumberInput from '../PartNumberInput';
const getAction = (item, deleteInvalidItem) => {
  return <DeleteAction item={item} deleteInvalidItem={deleteInvalidItem} />;
};
const getPartNumbers = (item, isValidParts) => {
  return isValidParts ? item.partNumber : <PartNumberInput item={item} />;
};
export const getCustomRenderers = (isValidParts, deleteInvalidItem) => ({
  actions: item => getAction(item, deleteInvalidItem),
  partNumber: item => getPartNumbers(item, isValidParts)
});
